import { DateTime } from 'luxon';
import {
  ProjectPlanningFilters,
  ProjectPlanningFiltersForm,
} from './hooks/use-project-planning-filters.types';
import {
  getBranchOffices,
  getDepartments,
  getJobTypes,
} from '../../../../../../hq/components/views/planner/shifts/filters/utils/utils';
import {
  OgpBusinessUnitsData,
  OgpJobTypesData,
} from '../../../../../services/ogp-shared-service.types';
import { ProjectGetWorkersResponse } from '../../../../../services/project-service.types';

export const getProjectPlanningDefaultValues = (
  appliedFilters: ProjectPlanningFilters,
  businessUnitData: OgpBusinessUnitsData,
  jobTypeData: OgpJobTypesData,
  workerData: ProjectGetWorkersResponse
): ProjectPlanningFiltersForm => {
  const toDate = appliedFilters.toDate
    ? appliedFilters.toDate.toFormat('yyyy-MM-dd')
    : DateTime.now().toFormat('yyyy-MM-dd');
  const result: ProjectPlanningFiltersForm = {
    toDate,
    branchOffices: null,
    departments: null,
    jobType: null,
    worker: null,
    jobTypeCheckboxValue: !!appliedFilters.jobType?.length,
    filledStatusCheckboxValue: !!appliedFilters.filledStatus,
    allowApplicantsFilter: appliedFilters.hasApplicants != null ? true : false,
    filledStatus: appliedFilters.filledStatus ? appliedFilters.filledStatus : 'inProgress',
    hasApplicants: appliedFilters.hasApplicants != null ? appliedFilters.hasApplicants : true,
    businessUnitCheckboxValue: !!appliedFilters.branchOffices?.length,
    toDateCheckboxValue: !!appliedFilters.toDate,
    allowWorkersFilter: !!appliedFilters.workerId,
  };

  if (appliedFilters.jobType?.length) {
    const jobTypes = getJobTypes(appliedFilters.jobType, jobTypeData.jobTypes);
    if (jobTypes.length > 0) {
      result.jobType = jobTypes.map((jt) => ({ id: jt.value, name: jt.label }));
    }
  }

  if (appliedFilters.branchOffices?.length) {
    result.branchOffices = getBranchOffices(
      appliedFilters.branchOffices,
      businessUnitData.branchOffices
    );
  }

  if (appliedFilters.departments?.length) {
    result.departments = getDepartments(appliedFilters.departments, businessUnitData.branchOffices);
  }

  if (appliedFilters.workerId) {
    const worker = workerData.find((i) => i.id === appliedFilters.workerId);
    if (worker) {
      result.worker = {
        label: worker.name,
        value: worker.id,
      };
    }
  }

  if (!appliedFilters.branchOffices?.length) {
    return result;
  }

  const branchOfficeFilter = businessUnitData.branchOffices.find((bo) =>
    appliedFilters.branchOffices?.includes(bo.branchOfficeId)
  );

  if (!branchOfficeFilter) {
    return result;
  }

  if (!appliedFilters.departments?.length) {
    return result;
  }

  const departmentFilter = branchOfficeFilter.departments.find((dept) =>
    appliedFilters.departments?.includes(dept.departmentId)
  );

  if (!departmentFilter) {
    return result;
  }

  return result;
};
